/**
 * Avvertenza esploso componenti di produzione.
 *
 * Intercetta il clic sui link all'esploso e mostra l'avvertenza; il file si
 * apre solo dopo la presa d'atto. Vedi snippets/esploso-warning-modal.liquid
 * per il perché non sta dentro il PDF.
 *
 * L'aggancio è in delega su document: i link nascono da Liquid (PDP), da
 * template literal (hub-hero) e da createElement (qrcode-linktree). Un
 * listener per punto sarebbe andato fuori sincrono al primo punto nuovo.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-esploso-link]';
  var modal = null;
  var confirmBtn = null;
  var pendingUrl = null;
  var lastFocused = null;

  function els() {
    if (!modal) {
      modal = document.getElementById('esploso-warning');
      confirmBtn = document.getElementById('esploso-warning-confirm');
      // Spostata in fondo al body, come fa ModalDialog in assets/global.js.
      // L'avvertenza e' renderizzata a meta' body e un tag non chiuso in un
      // frammento precedente se l'era gia' tirata dentro una volta (il cart
      // drawer, nascosto): li' restava invisibile e il clic sembrava non fare
      // nulla. Da qui in avanti sta sempre al livello del body, qualunque cosa
      // succeda al markup che la precede.
      if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    }
    return modal && confirmBtn;
  }

  function open(url) {
    if (!els()) return false;
    pendingUrl = url;
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('esploso-warning-open');
    // Il focus va sul bottone di conferma: da tastiera si legge il titolo
    // (aria-labelledby) e si prosegue senza dover tabulare nel dialog.
    confirmBtn.focus();
    return true;
  }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    pendingUrl = null;
    document.body.classList.remove('esploso-warning-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  document.addEventListener('click', function (e) {
    var dismiss = e.target.closest('[data-esploso-dismiss]');
    if (dismiss && modal && !modal.hidden) {
      e.preventDefault();
      close();
      return;
    }

    var link = e.target.closest(SELECTOR);
    if (!link) return;

    var url = link.getAttribute('href');
    if (!url) return;

    // Se la modale non è in pagina lasciamo passare il clic: meglio il file
    // senza avvertenza che un link morto.
    if (!open(url)) return;
    e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    if (!confirmBtn || e.target !== confirmBtn) return;
    var url = pendingUrl;
    close();
    if (!url) return;
    // Apriamo con un anchor sintetico, non con window.open: prima era
    // window.open(url, '_blank', 'noopener'), che per specifica restituisce
    // null anche quando la scheda si apre davvero. Il codice lo leggeva come
    // "popup bloccato" e ripiegava su location.href: il PDF finiva aperto due
    // volte, in scheda nuova e nella scheda corrente. Il click sull'anchor fa
    // esattamente quel che avrebbe fatto il link originale — stessa scheda
    // nuova, stesso rel="noopener" — senza valori di ritorno da interpretare.
    var a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });

  function focusabili() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
  }

  document.addEventListener('keydown', function (e) {
    if (!modal || modal.hidden) return;

    if (e.key === 'Escape') {
      close();
      return;
    }

    // Focus trap: senza, con Tab si finisce sulla pagina dietro la modale,
    // che e' proprio cio' che l'avvertenza deve impedire di scavalcare.
    if (e.key !== 'Tab') return;
    var f = focusabili();
    if (!f.length) return;
    var primo = f[0];
    var ultimo = f[f.length - 1];
    if (e.shiftKey && document.activeElement === primo) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primo.focus();
    } else if (!modal.contains(document.activeElement)) {
      e.preventDefault();
      primo.focus();
    }
  });
})();
